<script>
  import contentMap from '../../utils/ContentMapLayout';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';

  let {
    columnOneContent,
    translateUp = false,
    headingClasses = $bindable(),
    headingLevel = 'h2',
    headingText,
    containerStyles = '',
    fullWidth = false,
    noPadding = false,
    dataTestId = 'layout-one-column',
    itemscope = undefined,
    itemtype = undefined,
    itemprop = undefined,
  } = $props();

  let marginClasses = $state('my-6 md:my-10 lg:my-14');

  if (fullWidth && (containerStyles === 'blue' || containerStyles === 'gray')) {
    marginClasses = '';
  }

  if (containerStyles === 'border_bottom') {
    marginClasses = 'mb-6 md:mb-10 lg:mb-14';
  }

  if (containerStyles === 'border_top') {
    marginClasses = 'mt-6 md:mt-10 lg:mt-14';
  }

  let translateUpClasses = translateUp ? 'lg:transform lg:-translate-y-1/2' : '';

  if (headingText) {
    headingClasses = headingClasses
      ? headingClasses
      : 'font-semibold text-blue-dark-navy mx-4 mt-6 lg:mt-10 lg:mb-2 sm:text-center text-xl sm:text-1.5xl md:text-2xl lg:text-3xl';
  }
</script>

<div
  class="{marginClasses} {translateUpClasses}"
  class:max-w-6xl={!fullWidth}
  class:mx-auto={!fullWidth}
  class:bg-blue-very-light={containerStyles === 'blue' && fullWidth}
  class:bg-gray-mercury={containerStyles === 'gray' && fullWidth}
  class:px-4={containerStyles === '' || containerStyles === 'none'}
  class:lg:px-4={containerStyles === 'blue' || containerStyles === 'gray'}
  data-testid={dataTestId}
  {itemscope}
  {itemtype}
  {itemprop}
>
  {#if containerStyles === 'border_top' || containerStyles === 'borders_top_bottom'}
    <hr class="text-gray-light-silver {!noPadding ? 'mb-6 md:mb-10 lg:mb-14' : ''}" class:mx-4={!fullWidth} />
  {/if}

  <div
    class="px-4"
    class:max-w-6xl={fullWidth}
    class:mx-auto={fullWidth}
    class:bg-blue-very-light={containerStyles === 'blue' && !fullWidth}
    class:bg-gray-mercury={containerStyles === 'gray' && !fullWidth}
    class:lg:px-4={containerStyles === 'blue' || containerStyles === 'gray'}
    class:py-6={(containerStyles === 'blue' || containerStyles === 'gray') && !noPadding}
    class:lg:py-10={(containerStyles === 'blue' || containerStyles === 'gray') && !noPadding}
  >
    {#if headingText}
      <BaseHeading className={headingClasses} {headingLevel}>
        {headingText}
      </BaseHeading>
    {/if}
    <div class="flex flex-col lg:justify-around">
      {#each columnOneContent.imports as content (content.id)}
        {@const SvelteComponent = contentMap[content.__typename]}
        <SvelteComponent {...content} />
      {/each}
    </div>
  </div>

  {#if containerStyles === 'border_bottom' || containerStyles === 'borders_top_bottom'}
    <hr class="text-gray-light-silver {!noPadding ? 'mt-6 md:mt-10 lg:mt-14' : ''}" class:mx-4={!fullWidth} />
  {/if}
</div>
